// extracted by css-extract-rspack-plugin
export default {"close":"fqEy_TGaNHJRkzF5ycMR","fadeIn":"VRXCi9mE6u72KEKc4LLw"};